{
  "general": {
    "retry": "Retry",
    "cancel": "Cancel",
    "back_to_home": "Back to Home",
    "back": "Back",
    "menu": "Menu",
    "close": "Close",
    "edit": "Edit",
    "delete": "Delete",
    "complate": "Complate",
    "approve": "Approve",
    "select_all_users": "Select all users",
    "deselect_all_users": "Deselect all users",
    "search": "Search",
    "share": "Share",
    "suggestion": "Suggestion",
    "user": "User",
    "all_users": "All Metamory users",
    "group": "Group",
    "album": "Album",
    "address_book": "Address book",
    "other": "Other",
    "later": "Later",
    "storage": "Storage",
    "error": "Error",
    "append_photo": "Append photo",
    "delete_photo": "Delete photo",
    "remove_from": "Remove from {{name}}",
    "removed_photo_from": "Removed photo from {{name}}",
    "error_occurred": "An error occurred",
    "created": "Created {{name}}",
    "loading": "Loading...",
    "change": "Change",
    "password": "Password",
    "email": "Email",
    "set": "Set",
    "copied_clipboard": "Copied to clipboard",
    "copied_clipboard_error": "Copy to clipboard failed",
    "updated": "Updated",
    "please_select": "Please select",
    "appended": "Appended",
    "deleted": "Deleted",
    "login": "Login",
    "wip": "WIP",
    "coming_soon": "Coming soon",
    "photos_num": "{{num}} photos",
    "upgrade_plan": "Upgrade Plan",
    "reload_page": "Reload Page",
    "long_session_message": "You have been using this page for a long time. Would you like to refresh to get the latest updates?",
    "reload": "Reload",
    "open": "Open"
  },
  "header": {
    "profile": "Profile",
    "plan": "Plan",
    "setting": "Setting",
    "help": "Help & Feedback",
    "about": "About Metamory",
    "logout": "Logout",
    "select_icon": "Select icon"
  },
  "feature": {
    "home": "Home",
    "dm": "DM",
    "favorite": "Favorite",
    "my_photo": "My photo",
    "my_album": "My album",
    "share_album": "Share album",
    "notification": "Notifications",
    "invitation": "Invitations",
    "search_photo": "Search photo",
    "reaction": "Reaction",
    "trash": "Trash"
  },
  "time": {
    "just_now": "Just now",
    "minute_ago": "1 minute ago",
    "minutes_ago": "{{num}} minutes ago",
    "hour_ago": "1 hour ago",
    "hours_ago": "{{num}} hours ago",
    "yesterday": "Yesterday",
    "days_ago": "{{num}} days ago",
    "month_ago": "1 month ago",
    "months_ago": "{{num}} months ago",
    "year_ago": "1 year ago",
    "years_ago": "{{num}} years ago"
  },
  "upload": {
    "upload_photo": "Upload photo",
    "auto_upload_photo": "Auto upload photos",
    "uploading_photos": "Uploading photos",
    "drag_over": "Drop a photo to upload it",
    "upload_failed": "Upload failed",
    "upload_success": "Upload success",
    "storage_over_error": "Storage capacity exceeded",
    "file_count_over_error": "Maximum number of files reached",
    "file_format_error": "Illegal data file(e.g. resolution is too large, etc)",
    "file_break_error": "File is broken",
    "file_size_lower_error": "File size is too small (minimum 64KB)",
    "file_size_upper_error": "File size is too large (maximum 100MB)",
    "iligal_data_error": "Invalid data",
    "netrowk_error": "Network error",
    "cancel_error": "Canceled",
    "other_error": "Error",
    "iligal_data_error": "Invalid data",
    "capacity_error": "Capacity exceeded",
    "edit_icon": "Edit icon"
  },
  "photo_list": {
    "selected": "{{num}} selected",
    "selected_limit": "selected length limit is {{num}}",
    "footer": {
      "download": "Download",
      "download_zip": "Download as zip",
      "zip_compressing": "Compressing zip...",
      "append": "Append",
      "compare": "Comparison",
      "delete": "Delete",
      "download_error": "Download error",
      "download_success": "{{num}} photos download",
      "delete_confirm": "Are you sure you want to delete the selected {{num}} photos?",
      "delete_success": "{{num}} photos deleted"
    },
    "append_menu": {
      "new_album": "Create new album",
      "public_album": "Public album",
      "public_album_lock": "Public album(password lock)"
    }
  },
  "sort": {
    "append_time_new": "In order of addition",
    "append_time_old": "In order of addition (old)",
    "myphoto_append_time_new": "In order of created",
    "myphoto_append_time_old": "In order of created (old)",
    "updated_at": "In order of update",
    "reverse_updated_at": "In order of update (old)",
    "name_asc": "Name (A-Z)",
    "name_desc": "Name (Z-A)"
  },
  "photo": {
    "view_detail": "View photo details",
    "delete_from_album": "Delete from album",
    "delete": "Delete",
    "delete_confirm": "Move this photo to the trash?",
    "delete_confirm_description": "It will also be removed from albums, DMs, and other places.",
    "user_tag": "User tag",
    "create_share_album": "Create share album",
    "search": "Filter photos by user",
    "only_my_photo": "Only my photo",
    "new_favorite": "Create and add a new favorite album",
    "add_result": "Added to {{name}}",
    "add_favorite_result": "Added to favorites \"{{name}}\"",
    "change_favorite": "Change favorite",
    "tagged_users": "Tagged users",
    "add_user_not_candidate": "Add a user who is not candidates",
    "select_tag_user_title": "Select user to tag",
    "not_registered": "Unregistered Metamory user",
    "share_success": "Photo shared",
    "share_error": "Failed to share photo",
    "share_not_supported": "Your browser does not support photo sharing",
    "share_prepared": "Photo prepared. Please tap again to share",
    "add_users_from_edit": "Add users from \"Edit\"",
    "no_tagged_users": "No tagged users",
    "users_in_instance": "Users in instance",
    "take_photo_with_others_or_enable_log": "Take photos in instances with other users or enable log file output",
    "install_sync_tool": "Install photo sync tool",
    "auto_sync_users": " to automatically sync users in photos",
    "all_users_tagged": "All users are tagged",
    "add_favorite_result": "Added \"{{name}}\" to favorites"
  },
  "myphoto_tutorial": {
    "title": "Install Metamory's photo sync tool!",
    "description": "What you can do with the photo sync tool",
    "li1": "Automatic photo uploading",
    "li2": "Automatically link users in photos",
    "li3": "Automatically retrieve world information",
    "li4": "Date determination according to play time",
    "download": "Download Metamory's photo sync tool",
    "upload": "Upload photos without installing the photo sync tool",
    "tutorial_link_text": "For instructions on installing, starting, and closing the photo sync tool, please see the",
    "tutorial_link": "tutorial",
    "tutorial_link_suffix": "",
    "download_now": "Download Now"
  },
  "reaction_selector": {
    "search_no_results_2": "That reaction couldn’t be found",
    "pick": "Pick an reaction...",
    "frequent": "Frequent used"
  },
  "home": {
    "main": "Main",
    "my_photos": "My Photos",
    "vket": "Vket 2025 Summer",
    "new_photos_available": "{{count}} new photos available",
    "refresh": "Refresh",
    "storage_warning": "Storage space is running low!"
  },
  "tutorial": {
    "title": "Welcome to Metamory!",
    "description": "To get the most out of Metamory, let's complete a task!",
    "profile_title": "Complete your profile",
    "profile_description": "Add a photo, a description of yourself, and account information for other services to your profile to make it easier for other users to find you!",
    "share_title": "Create a share album",
    "share_description": "Create a share album to show other users the photos you've taken and have them share photos of you!",
    "pc_client_title": "Install the photo sync tool",
    "pc_client_description": "With the photo sync tool, you can eliminate forgetting to move photos, wondering who this person is, or where this was taken!"
  },
  "favorite": {
    "create_list": "Create a new favorite list",
    "special_favorite_name": "favorite",
    "no_title_favorite": "No title favorite",
    "no_photos_title": "No favorite photos",
    "no_photos_description": "Add a photo to your favorites and look back on your memories",
    "edit_favorite": "Edit favorite",
    "delete_favorite_confirm": "Are you sure you want to delete this favorite list?"
  },
  "notification": {
    "no_notification": "No notifications",
    "no_notification_description": "Notifications sent to you will appear here",
    "no_invitation": "No invitations",
    "no_invitation_description": "Invitations to shared albums will appear here",
    "share_album_append": "{{num}} photos have been added",
    "share_album_invitation": "You have been invited to {{name}}",
    "share_album_owner_transferred": "You are now the owner of {{name}}",
    "share_album_invitation_accept": "Accept",
    "invitation_accepted": "Invitation accepted",
    "joined_album": "Joined {{albumName}}"
  },
  "album": {
    "create_album": "Create album",
    "no_title_album": "No title album",
    "number_of_photos": "{{num}} photos",
    "add_photo": "Add photo",
    "invitation_album": "Invitation album",
    "get_link": "Get link",
    "no_photos": "No photos",
    "album_no_photo": "Album has no photos",
    "album_no_photo_description": "Share your memories by adding photos to this album.",
    "delete_album_success": "Album deleted",
    "delete_album_confirm": "Are you sure you want to delete this album?",
    "confirm_change_share": "Do you want to share this album?\n(Cannot return to MyAlbum)"
  },
  "share": {
    "not_found_title": "Album not found",
    "not_found_description": "The album may have been deleted or the URL may be incorrect.",
    "back_to_share_list": "Back to shared album list",
    "empty_shares_title": "Create a shared album and share your photos with everyone!",
    "empty_shares_description": "Create a shared album and add photos to it to share your photos with other users, or have other users share their photos with you!",
    "create_share_album": "Create shared album",
    "share_range": "Shared range",
    "share_range_description": "You can choose to whom you want to share the album",
    "invite_only": "Owner can invite only",
    "invite_only_description": "Only users you invite to your album can participate",
    "invite_plus": "Anyone can invite",
    "invite_plus_description": "Users you invite to an album can invite other users to the album",
    "public": "Public",
    "public_description": "Anyone who knows the link can view it",
    "public_lock": "Public(password lock)",
    "public_lock_description": "Anyone who knows the link and password can view it",
    "invite_only_public_view": "Public (only owner can invite editors)",
    "invite_only_public_view_description": "Member management is invite-only, but anyone with the link can view and react",
    "invite_plus_public_view": "Public (editors can invite editors)",
    "invite_plus_public_view_description": "Invited users can invite others, and anyone with the link can view and react",
    "member_list": "Member list",
    "leave_share_album": "Leave shared album",
    "leave_share_album_confirm": "Are you sure you want to leave this shared album?",
    "leave_share_album_success": "Left shared album",
    "edit_album": "Edit album",
    "delete_album": "Delete album",
    "approval_awaiting_list": "Approval awaiting list",
    "album_login_required": "You need to log in to Metamory\nto view and edit this album",
    "approval_awaiting_users": "Approval awaiting users",
    "approval_awaiting_empty_title": "No users awaiting approval",
    "approval_awaiting_empty_description": "There are currently no users awaiting approval.\nNew participation requests will appear here.",
    "invitation_users": "Invited Users",
    "invitation_users_list": "Invited Users List",
    "invitation_empty_title": "No invited users",
    "invitation_empty_description": "There are currently no invited users.\nInvited users will appear here.",
    "invitation_canceled": "Invitation canceled",
    "cancel_invitation_confirm": "Do you want to delete this user's invitation?\n(You will need to invite them again for them to join the album)",
    "cancel_invitation_button": "Delete invitation",
    "auto_approval": "Automatic approval of participation applications",
    "auto_approval_description": "When ON, participation requests to join the album (with viewing and editing permissions) are automatically approved.\nWhen OFF, they are registered in the album's \"Approval Awaiting User List\"",
    "share_type_change_warning_title": "Confirm Share Settings Change",
    "warning_public_to_private": "Changing to invitation-only will restrict existing access permissions.",
    "warning_private_to_public": "Changing to public will make it accessible to more people.",
    "warning_invite_permission_change": "Member invitation permissions will be changed.",
    "confirm_change": "Confirm Change",
    "change_owner": "Change album owner",
    "change_owner_confirm": "If you change the album owner, you will not be able to set up the album",
    "change_owner_button": "Change owner",
    "change_owner_success": "Album owner changed",
    "select_owner_empty_title": "No members available to change ownership",
    "select_owner_empty_description": "To change the owner, please invite members to the album.\nOwnership cannot be changed when there are no members.",
    "add_users_title": "Invite Users",
    "add_users_empty_title": "Search for users",
    "add_users_empty_description": "Enter a username or ID in the search box above\nto find users you want to invite.",
    "join_request_message": "You need to request to join this album to view and edit it",
    "request_to_join": "Request to Join",
    "join_request_success": "Join request sent",
    "join_auto_approved": "You have joined the album",
    "users_approved": "Users approved",
    "invite_users": "Invite Users",
    "invited_users": "Invited Users",
    "cancel_invitation": "Cancel Invitation",
    "invited_by": "Invited by {{name}}",
    "accept_invitation": "Accept",
    "decline_invitation": "Decline",
    "user_invited": "User invited",
    "viewing_password": "Viewing password",
    "set_viewing_password": "Set viewing password",
    "set_viewing_password_success": "Viewing password set",
    "enter_password": "A password is required to view and edit this album",
    "view": "View",
    "password_error": "Password error",
    "member": "Member",
    "kick_from_album": "Kick from album",
    "kick_success": "Kicked from album",
    "delete_share_confirm": "Do you want to delete this album? (If you delete it, other users will not be able to view the album)",
    "leave_share_confirm": "Do you want to leave from this album?\n(If you withdraw from the album, you will not be able to view the album)",
    "leave": "Leave",
    "link_copied": "Share link copied",
    "login_dialog": "To view or edit this album, You must be logged in to Metamory.",
    "encourage_register_message": "Register with Metamory and\nshare your albums with friends",
    "start_metamory": "Get Started with Metamory",
    "is_sensitive_label": "Sensitive Album",
    "is_sensitive_description": "When enabled, users under 18 years old will not be able to view this album"
  },
  "modal": {
    "logout_message": "Are you sure you want to log out?",
    "confirm_leave_page": "Are you sure you want to leave this page?",
    "leave_page": "Leave page",
    "confirm_discard_edit": "Your edits have not been saved. Discard them and close?",
    "discard_edit": "Discard and close",
    "login_confirm": "You are about to navigate to the login page.\nPress \"Go\" to continue."
  },
  "popup_menu": {
    "choice_favorite": "Choice favorite",
    "choice_reaction": "Add reaction",
    "reaction_detail": "Reaction detail",
    "photo_detail": "Photo detail",
    "create_myalbum": "Create new MyAlbum",
    "choice_photo_append_type": "Choice photo append type",
    "choice_photo_append_myalbum": "Choice photo append my album",
    "choice_photo_append_share": "Choice photo append share album",
    "choice_photo_append_public_album": "Choice photo append public album",
    "choice_photo_append_public_lock_album": "Choice photo append public album(password lock)",
    "choice_photo_append_favorite": "Choice photo append favorite",
    "choice_photo_append_dm": "Choice photo append DM"
  },
  "address_book": {
    "add_user": "Add new user",
    "empty_user_title": "No users in the address book",
    "empty_user_description": "Add a user to the address book to share photos with them",
    "create_group": "Create group",
    "empty_group_title": "No groups created",
    "empty_group_description": "Register users into groups for smooth sharing!",
    "book_user": "Add user to address book"
  },
  "user": {
    "add_book": "Register",
    "add_book_success": "Registered",
    "in_book": "Registered",
    "add_group": "Add group",
    "outbook_dialog_message": "Do you want to unregister this user?\n(You can re-register later)",
    "out_book": "Unregister",
    "mute_user": "Mute this user",
    "unmute_user": "Unmute this user",
    "mute_dialog_message": "Do you want to mute this user?\n(You will not be able to see photos of users you have muted)",
    "mute": "Mute",
    "mute_warning": "You have muted this user, so you cannot see photos or reactions added by this user",
    "muted_user": "User muted",
    "report_user": "Report User",
    "report_this_user": "Report This User",
    "report_dialog_message": "Please select the content that violates the guidelines",
    "report_reason_icon": "Inappropriate profile picture",
    "report_reason_icon_detail": "Using photos that violate guidelines as profile picture, etc.",
    "report_reason_name": "Inappropriate username/ID",
    "report_reason_name_detail": "Username or ID contains words that violate guidelines, etc.",
    "report_reason_description": "Inappropriate bio",
    "report_reason_description_detail": "Bio contains words that violate guidelines, etc.",
    "report_reason_other": "Other",
    "report_reason_other_detail": "Content that violates guidelines but doesn't fit the above categories",
    "reported_user": "User reported",
    "report_error_user_not_found": "User not found",
    "unmuted_user": "User unmuted",
    "add_group_success": "Added to group '{{name}}'",
    "search_no_result": "No results match your search criteria",
    "search_no_result_description": "Entering an exact username or searching by user ID will help you find friends",
    "search_friend_not_found": "What if I can't find a friend?",
    "search_friend_not_found_description": "It is easier to find friends if you type in their exact user name or search by user ID!",
    "frozen_account": "This account has been frozen for violating <l>Metamory's Terms of Service</l>.",
    "frozen_user_name": "Frozen User"
  },
  "profile": {
    "edit_profile": "Edit profile",
    "edit_profile_success": "Profile edited",
    "user_id": "User ID",
    "user_id_char_error": "Please enter alphanumeric characters",
    "user_name": "User name",
    "user_description": "User introduction",
    "collaboration_other_service": "Collaboration with other services",
    "vrchat_input_hint": "VRChat user page URL will be automatically converted (e.g.https://vrchat.com/home/user/usr_XXXXX)",
    "twitter_input_hint": "X(Twitter) user page URL will be automatically converted(e.g.https://x.com/XXXXX)",
    "exist_metamory_id": "This ID already exists"
  },
  "group": {
    "no_title_group": "No title group",
    "edit_group": "Edit group",
    "delete_group": "Delete group",
    "delete_group_confirm": "Are you sure you want to delete this group?",
    "users_length": "{{num}} users belong to this group",
    "users_0": "No users belong to this group",
    "add_user": "Adding users to group",
    "add_user_min": "Add user",
    "no_user": "No users in this group",
    "no_user_description": "Add users to this group to share photos with them",
    "san": "{{name}}",
    "comma": ","
  },
  "dm": {
    "create_dm": "Create DM",
    "no_dms": "No DMs",
    "no_dms_description": "Find your friends and send them a DM!",
    "no_photos_title": "DM has no photos",
    "no_photos_description": "Share your memories by adding photos to this DM",
    "dm_title": "{{name}}'s DM",
    "append_photos": "Added photos to {{name}}'s DM",
    "search_user": "Search user",
    "search_user_description": "Search for users to create DMs to"
  },
  "auth": {
    "current_password": "Current password",
    "new_password": "New password",
    "confirm_new_password": "Confirm new password",
    "update_password": "Update password",
    "passwords_must_match": "Passwords must match",
    "attempt_limit_exceeded": "Too many attempts. Please wait a while and try again",
    "password_too_long": "Password must be no more than 256 characters",
    "password_edge_whitespace": "Password cannot start or end with a space",
    "password_policy": "At least {{num}} characters",
    "show_password": "Show {{field}}",
    "hide_password": "Hide {{field}}",
    "invalid_credentials": "Incorrect email address or password",
    "incorrect_current_password": "The current password is incorrect",
    "session_expired": "Your sign-in has expired. Please sign in again",
    "invalid_code": "The verification code is incorrect or has expired",
    "network_error": "Connection failed. Check your connection and try again",
    "unexpected_error": "The operation failed. Please try again",
    "username_exists": "This email address is already registered",
    "invalid_password": "The password does not meet the requirements",
    "sign_in": "Sign in",
    "sign_up": "Sign up",
    "forgot_password": "Forgot your password?",
    "back_to_sign_in": "Back to sign in",
    "create_account": "Create account",
    "confirm_sign_up_title": "Verify your email address",
    "confirm_sign_up_description": "Enter the verification code sent to {{email}}",
    "confirmation_code": "Verification code",
    "confirm": "Confirm",
    "resend_code": "Resend code",
    "code_resent": "The verification code has been resent",
    "reset_password_title": "Reset password",
    "reset_password_description": "We will send a verification code to your registered email address",
    "send_code": "Send code",
    "reset_password_code_description": "Enter the verification code sent to {{email}} and a new password",
    "reset_password": "Reset password",
    "password_reset_done": "Your password has been reset. Please sign in with your new password",
    "sign_up_confirmed": "Registration complete. Please sign in",
    "already_confirmed": "This email address is already verified. Please sign in",
    "user_not_found": "No account was found for this email address",
    "unverified_reset": "This account hasn't been verified, so its password can't be reset. Sign in to get a new verification code",
    "contact_admin": "This account requires a password to be set. Please contact us from Help and feedback",
    "continue": "Continue",
    "checking_passkey": "Checking for a passkey…",
    "retry_with_passkey": "Retry with passkey",
    "use_different_email": "Use a different email",
    "password_step_hint": "Enter your password to sign in",
    "passkey_canceled_hint": "Passkey sign-in was canceled. Enter your password, or try your passkey again",
    "passkey_failed_hint": "Couldn't sign in with a passkey. Enter your password, or try your passkey again"
  },
  "setting": {
    "profile_title": "Profile settings",
    "profile_description": "You can set up account email address, passwords, etc",
    "notification_title": "Notification settings",
    "notification_description": "Manage notifications sent by Metamory",
    "display_and_accessibility_title": "Display and accessibility settings",
    "display_and_accessibility_description": "You can configure the screen display and language",
    "ui_theme_title": "UI Theme",
    "ui_theme_description": "Configure the UI theme",
    "color_mode_system": "Follow system setting",
    "color_mode_light": "Light mode",
    "color_mode_dark": "Dark mode",
    "client_application_title": "Photo sync tools",
    "client_application_description": "Photo sync tools can be downloaded and configured",
    "language_title": "Language",
    "language_description": "Select your display language",
    "language_japanese": "日本語",
    "language_english": "English",
    "language_korean": "한국어",
    "account_setting": "Account settings",
    "set_new_password": "Set new password",
    "delete_account": "Delete account",
    "delete_account_confirm": "Are you sure you want to delete your account?",
    "change_email": "Change email address",
    "change_email_description": "Change the email address associated with your account",
    "current_email": "Current email address",
    "new_email": "New email address",
    "confirm_code_title": "Enter the Verification code",
    "verification_code": "Verification code",
    "confirmation_email_sent": "Confirmation email sent",
    "change_password": "Change password",
    "change_password_description": "Change the password associated with your account",
    "passkey_description": "Sign in with your fingerprint, face, or screen lock",
    "password_updated": "Password updated",
    "metamory_id": "Metamory ID",
    "your_metamory_id": "Your Metamory ID",
    "delete_account_input_confirm": "If you wish to delete your account, please enter your Metamory ID for verification",
    "notification": {
      "share_reaction": "Reaction to shared album photo",
      "share_add_photo": "Add photo to shared album",
      "share_name_change": "Change shared album name",
      "share_type_change": "Change shared album type",
      "dm_reaction": "Reaction to DM photo",
      "dm_receive": "Receive DM"
    },
    "client_application": {
      "title": "Photo sync tool settings",
      "tutorial_instruction": "Please refer to the tutorial below for instructions on installing, starting, and closing the photo sync tool",
      "tutorial_button": "Photo Sync Tool Tutorial",
      "installed_devices": "Devices with Photo Sync Tool Installed",
      "installed_devices_description": "A list of devices currently used for syncing",
      "device_disconnect": "Disconnect device",
      "device_disconnect_description": "To reconnect a disconnected device, open the photo sync tool of the device you wish to connect and reconfigure it",
      "disconnect": "Disconnect",
      "disconnect_confirm": "Do you want to disconnect this device? (Disconnecting will also stop the automatic upload)",
      "client_application_download": "Download photo sync tool",
      "client_application_download_description_mobile": "Download the photo sync tool to automatically upload photos taken with your device to Metamory",
      "client_application_download_description_pc": "Download the photo sync tool to automatically upload photos taken with your device to Metamory",
      "download_pwa": "Download Web App",
      "download_pwa_description": "(If you are using Google Chrome)\nYou can add Metamory to your smartphone by pressing \"Add to Home Screen\" from the \"Extras\" menu"
    },
    "privacy_and_safety_title": "Privacy and Safety",
    "privacy_and_safety_description": "Manage muted users and other privacy settings",
    "muted_users_title": "Muted Users",
    "muted_users_description": "View and manage users you have muted",
    "muted_users_header": "Muted Users",
    "muted_users_empty_title": "No Muted Users",
    "muted_users_empty_description": "Users you mute will appear here",
    "unmute_dialog_message": "Do you want to unmute this user?",
    "unmute_button": "Unmute",
    "unmuted_user_success": "User unmuted successfully"
  },
  "welcome": {
    "welcome": "Welcome to Metamory!",
    "description": "First, set up your profile,\nMake it easy for your friends to find you!",
    "set_profile": "Set profile",
    "sign_out_description": "If you have registered with the wrong account, click here",
    "sign_out": "Sign out"
  },
  "help": {
    "how_to_use_title": "How to use Metamory",
    "how_to_use_description": "Click here to learn how to use each Metamory feature",
    "populer_question_title": "Popular questions",
    "populer_question_description": "Frequently asked questions are answered in a Q&A format",
    "feedback_title": "Feedback",
    "feedback_description": "Please contact us to report a bug or improve a feature (you will be redirected to the official Metamory Discord server)",
    "discord_title": "Official Discord Community",
    "discord_description": "If you want to interact with Metamory users and management, click here!",
    "go_out_site_confirm": "Are you sure you want to leave the site?",
    "go": "Go",
    "go_discord_confirm": "You will be redirected to the official Metamory server (Discord)",
    "go_discord": "Go",
    "privacy_policy_and_terms_description": "Learn more about Metamory's Terms of Use and Privacy Policy"
  },
  "trash": {
    "moved_to_trash": "Moved photo to trash",
    "open_trash": "Open trash",
    "empty_trash": "Empty trash",
    "empty_trash_description": "If you delete a photo, it will be stored in the trash for 30 days",
    "restore": "Restore to MyPhoto",
    "delete_from_trash": "Completely delete",
    "delete_all_from_trash": "Complately delete from trash",
    "delete_from_trash_confirm": "Do you want to delete {{num}} photos?\n(Photos will be completely deleted from Metamory)",
    "deleted_from_trash": "Deleted from trash",
    "deleting_in_background": "Deleting in background",
    "processing_in_background": "Processing in background",
    "restored_from_trash": "Restored from trash",
    "trashed_on": "Trashed {{date}}"
  },
  "search": {
    "user": "{{name}}'s photo",
    "owner": "Photographer",
    "in_users": "User in photo"
  },
  "accept_rules": {
    "mobile_title": "Revision of Terms of Use",
    "dialog_title": "New Privacy Policy",
    "dialog_description": "Metamory's Privacy Policy has been revised. Please see the <l>Terms of Use</l> for details",
    "accept": "Agree and proceed"
  },
  "error": {
    "occurred": "An error occurred",
    "occurred_message": "Sorry.\nPlease refresh your browser and try the operation again.\nPlease restart Metamory if you installed on a smartphone, Chrome, etc.\nIf this screen appears repeatedly, please submit feedback.",
    "occurred_with_trace": "An error occurred (Trace ID: {{traceId}})",
    "text_length_over": "Character count exceeds {{limit}} characters (currently {{num}} characters)",
    "text_bytes_over": "Byte count exceeds {{limit}} bytes (currently {{num}} bytes)",
    "text_length_fewer": "Character count is less than {{limit}} characters (currently {{num}} characters)",
    "404_title": "Page not found",
    "404_description": "I did my best to find it, but I could not find the page you are looking for",
    "general": "An error occurred",
    "update": "Failed to update",
    "update_with_trace": "Failed to update (Trace ID: {{traceId}})",
    "analysis_info": "Error analysis information",
    "photo_not_found": "Photo not found",
    "photo_not_found_with_trace": "Photo not found (Trace ID: {{traceId}})",
    "fetch": "Failed to fetch data",
    "fetch_with_trace": "Failed to fetch data (Trace ID: {{traceId}})",
    "fetch_limit_stop": "Stopped due to many identical server requests occurring at once",
    "fetch_data_with_trace": "Failed to fetch data (Trace ID: {{traceId}})",
    "fetch_me": "Failed to fetch user data",
    "fetch_me_with_trace": "Failed to fetch user data (Trace ID: {{traceId}})",
    "fetch_notifications": "Failed to fetch notification data",
    "fetch_notifications_with_trace": "Failed to fetch notification data (Trace ID: {{traceId}})",
    "create": "Failed to create",
    "create_with_trace": "Failed to create (Trace ID: {{traceId}})",
    "delete": "Failed to delete",
    "delete_with_trace": "Failed to delete (Trace ID: {{traceId}})",
    "upload": "Failed to upload"
  },
  "photo_editor": {
    "title": "Edit photo",
    "menu_label": "Edit photo",
    "upload_success": "Edited photo saved",
    "crop_free": "Free",
    "crop_full": "Full",
    "aspect_ratio_label": "Ratio",
    "rotate_label": "Rotate",
    "rotate_left": "Rotate left",
    "rotate_right": "Rotate right",
    "share_to_x": "Post to X",
    "share_to_x_copied": "Image copied.\nOpen X with the button below and paste to post.",
    "share_to_x_open": "Open X",
    "share_to_x_error": "Failed to copy image to clipboard"
  },
  "photo_sticker": {
    "title": "Create sticker",
    "menu_label": "Create sticker",
    "coach_mark": "Try creating a sticker!",
    "select_photo": {
      "leave_confirm": "Stop choosing a photo for your sticker?",
      "title": "Choose a photo for your sticker",
      "guide_title": "Tap a photo to make a sticker"
    },
    "settings_tabs": "Sticker settings",
    "border_tab": "Border",
    "text_tab": "Text",
    "watermark_tab": "Watermark",
    "preview": "Sticker preview",
    "border_size_label": "Border",
    "border_color_label": "Border color",
    "text_input_label": "Text",
    "text_font_label": "Font",
    "text_font_name_default": "Default",
    "text_font_group_standard": "Standard",
    "text_font_group_japanese": "Japanese",
    "text_font_group_korean": "Korean",
    "text_font_group_latin": "Latin",
    "text_font_loading": "Loading font",
    "text_font_load_error": "Couldn't load the font. Check your connection and try again.",
    "prepare_error": "Couldn't load the image. Please try again.",
    "text_size_label": "Text size",
    "text_italic_label": "Italic",
    "text_placement_label": "Layer",
    "text_behind": "Behind",
    "text_front": "Front",
    "text_color_label": "Text color",
    "text_background_label": "Background",
    "text_background_none": "None",
    "text_background_outline": "Outline",
    "text_background_bubble": "Bubble",
    "text_outline_color_label": "Text outline",
    "text_outline_color_short": "Outline color",
    "bubble_color_label": "Bubble color",
    "bubble_border_color_label": "Bubble border color",
    "bubble_color_short": "Fill",
    "bubble_border_color_short": "Border",
    "bubble_border_none": "No bubble border",
    "bubble_tail_label": "Tail direction",
    "bubble_tail_up_left": "Up-left",
    "bubble_tail_up": "Up",
    "bubble_tail_up_right": "Up-right",
    "bubble_tail_right_up": "Right-up",
    "bubble_tail_right": "Right",
    "bubble_tail_right_down": "Right-down",
    "bubble_tail_down_right": "Down-right",
    "bubble_tail_down": "Down",
    "bubble_tail_down_left": "Down-left",
    "bubble_tail_left_down": "Left-down",
    "bubble_tail_left": "Left",
    "bubble_tail_left_up": "Left-up",
    "watermark_label": "Watermark",
    "upload_to_vrchat": "Upload to VRChat",
    "vrchat_upload_description": "Download a PNG sized to {{max}}px for VRChat stickers.\nAfter downloading, choose the image on the VRChat sticker upload page.",
    "download_for_vrchat": "Download for VRChat",
    "open_vrchat_upload": "Open upload page",
    "download": "Download",
    "remaining": "{{count}} left",
    "remaining_exhausted": "Next week",
    "quota_exceeded": "You've reached this week's sticker limit. Available again next week.",
    "confirm_close_without_export": "If you close this screen, the sticker you are editing will not be saved, and your sticker creation count will not be restored. Stop creating this sticker?",
    "close_without_export": "Stop"
  },
  "campaign": {
    "vket2025summer_applied": "Campaign has been applied\nMaximum photo storage limit increased to 2000 photos",
    "applied": "Campaign has been applied!"
  },
  "pr": {
    "vket": {
      "post_timeline": "Post to Vket timeline",
      "cancel_post_timeline": "Cancel posting",
      "already_post_timeline": "Already posted to Vket timeline",
      "success_post_timeline": "Posted to Vket timeline",
      "error_post_timeline": "Could not post, please try again",
      "already_posted": "This photo has already been posted to Vket timeline",
      "no_world_info": "No world information available. Please install the photo sync tool",
      "not_world": "Cannot post from non-Vket 2025 Summer worlds"
    },
    "honda2026": {
      "post_timeline": "Post to Honda Motanion timeline",
      "cancel_post_timeline": "Cancel posting",
      "already_post_timeline": "Already posted to Honda Motanion timeline",
      "success_post_timeline": "Posted to Honda Motanion timeline",
      "error_post_timeline": "Could not post, please try again",
      "already_posted": "This photo has already been posted to Honda Motanion timeline",
      "no_world_info": "No world information available. Please install the photo sync tool",
      "not_world": "Cannot post from non-Honda Motanion worlds"
    },
    "vket2025winter": {
      "start_metamory": "Get Started with Metamory",
      "benefit_timing_title": "Benefit Distribution Period",
      "benefit_timing_date": "End of January 2026",
      "condition1_title": "【Condition 1】How to Get Metamory 1,500 Photos Benefit",
      "condition1_step1": "Achieve Grandmaster in Vket 2025 Winter",
      "condition1_step1_detail": "Details on how to achieve Grandmaster are available",
      "condition1_step1_link": "here",
      "condition1_step2": "If you haven't registered for Metamory yet",
      "condition1_step2_link": "here",
      "condition1_step2_1": "Please proceed with registration",
      "condition1_step2_2": "After registering for Metamory, install and log in to the PC app",
      "condition1_step2_note": "※If you are unable to install or log in, please check the support below",
      "condition1_step2_help": "Metamory Help Page",
      "condition1_step2_discord": "Metamory User Community Discord",
      "condition1_step3": "If you are already registered for Metamory",
      "condition1_step3_detail": "No action required!",
      "condition1_step4": "Process complete!",
      "condition1_step4_detail": "The limit will be automatically reflected around the end of January 2026",
      "condition2_title": "【Condition 2】How to Get Metamory 2,000 Photos Benefit",
      "condition2_step1": "Create a 'Shared Album' after completing【Condition 1】",
      "condition2_step1_detail": "Create and publish an album from 'Shared Album' > 'Create New Album' on the home screen (album type doesn't matter)",
      "condition2_step2": "Process complete!",
      "condition2_step2_detail": "The limit will be automatically reflected around the end of January 2026",
      "faq_title": "FAQ",
      "faq_q1": "Q. If I'm already registered for Metamory and have installed and logged into the PC app, will I automatically get 1,500 photos when I achieve Grandmaster?",
      "faq_a1": "A. Yes, you will automatically get 1,500 photos!",
      "faq_a1_detail": "The limit will be reflected around the end of January 2026, so please wait",
      "faq_q2": "Q. I didn't register for Metamory after achieving Grandmaster. What is the expiration date of the benefit?",
      "faq_a2": "A. It expires on January 18, 2026!",
      "faq_a2_detail": "Please note that benefits cannot be granted after the expiration date",
      "faq_q3": "Q. If my storage limit is already 1,000 photos or more from past Metamory campaigns, will I get additional photos? (If I currently have 2,000 photos, will it become 3,500?)",
      "faq_a3": "A. No additional photos will be added...!",
      "faq_a3_detail": "Rest assured that if your limit is already 2,000 photos, achieving【Condition 1】will not downgrade it to 1,500 photos",
      "top_image_alt": "Vket 2025 Winter top image",
      "middle_image_alt": "Vket 2025 Winter main image"
    }
  },
  "about": {
    "sticker_tutorial": {
      "images": {
        "result": "Finished sticker with text and a border",
        "create": "Create sticker option in the photo viewer menu",
        "edit": "Sticker editor showing the Border and Text tabs and border controls"
      },
      "title": "Create a sticker from your photo",
      "choose_photo": "Create a sticker from My Photos",
      "back": "Back",
      "result": {
        "title": "The finished sticker",
        "body": "Cut out the subject of a photo and add text and an outline to make your own sticker."
      },
      "open": {
        "title": "1. Open a photo",
        "body": "Open a photo from <photos>My Photos</photos>.",
        "note": "My Photos shows photos you uploaded. You cannot create stickers from other people’s photos."
      },
      "create": {
        "title": "2. Start creating",
        "body": "Open the menu (⋮) at the top right of the photo viewer and select “Create sticker”.",
        "note": "There is a weekly creation limit. If you reach it, you can create more the following week."
      },
      "edit": {
        "title": "3. Customize it",
        "body": "Adjust the border in “Border” and add words in “Text”. You can choose the font, size, color, and speech bubble background."
      },
      "save": {
        "title": "4. Save and use it",
        "body": "Select “Download” to save the image. To use it in VRChat, open the share menu, select “Upload to VRChat”, then select “Download for VRChat”. Upload the downloaded sticker from VRChat’s sticker upload page."
      }
    },
    "info": "Infomation",
    "view_old_info": "View older infomations",
    "hide_old_info": "Hide older infomations",
    "register_account": "Register and get started",
    "wish_openbeta_account": "Login to Metamory",
    "goto_metamory": "Go to Metamory",
    "twitter_link": "Metamory's Official X",
    "privacy_policy_description": "Please refer to the <l>Privacy Policy Page</l> for more information.",
    "help_description": "If you have any trouble operating or managing your account, please check <l>Help Page</l>.",
    "privacy_policy_and_terms": "Privacy Policy and Terms of Use",
    "child_safe_policy": "Child Safety Policy",
    "tradelaw": "Act on Specified Commercial Transactions",
    "faq": {
      "faq": "Frequently asked questions",
      "how_to_use": "How to use Metamory",
      "contact": "Contact"
    },
    "client_tutorial": {
      "title": "Photo Sync Tool Tutorial",
      "table_of_contents": "Contents",
      "contents": {
        "download": "1. Download",
        "install": "2. Install",
        "confirm": "3. Launch Check",
        "faq": "FAQ"
      },
      "images": {
        "settings_screen": "Settings screen",
        "download_button": "Download button",
        "download_file": "Downloaded file",
        "windows_protection": "Windows protection screen",
        "signin_screen": "Sign-in screen",
        "browser_auth_screen": "Browser authentication screen",
        "syncing_device": "Synced device",
        "notification_area": "Notification area",
        "dashboard": "Dashboard"
      },
      "download": {
        "title": "1. Download the Photo Sync Tool",
        "step1": "Open \"Settings\" from \"Other\" in the side menu, then click \"Photo Sync Tool\".",
        "step2": "Press the \"Download Photo Sync Tool\" button to download the installer.",
        "step2_note": "The photo sync tool cannot be downloaded on smartphones. Please use your PC.",
        "step3": "Confirm that \"MetamoryClient_x64-setup.exe\" has been downloaded."
      },
      "install": {
        "title": "2. Install the Photo Sync Tool",
        "step1": "Double-click the \"MetamoryClient_x64-setup.exe\" file you downloaded earlier to launch it.",
        "step1_note": "If you see \"Windows protected your PC,\" click \"More info\" and then click \"Run anyway\" at the bottom right.",
        "step3": "If a prompt asks whether to allow this unknown publisher to make changes to your device, select \"Yes.\"",
        "step4": "When you see \"Setup Wizard Completed,\" you can close the installer.",
        "step5": "On first launch, a screen like this will appear.",
        "step5b": "Click the \"Sign in with Metamory\" button and your browser will open automatically, showing a screen like this.",
        "step5_email": "Enter the email address you used to create your Metamory account in \"Email address\" and your Metamory account password in \"Password.\"",
        "step5_success": "When you see \"Authentication successful! You can close this window.\", authentication is complete. You may close the page."
      },
      "confirm": {
        "title": "3. Confirm Launch and Exit",
        "step1": "Once installation is complete, the Metamory Photo Sync Tool starts automatically. After that, it launches whenever you start your PC and automatically syncs photos taken in VRChat.",
        "step1_note": "If the photo sync tool has launched correctly and login authentication has completed, you can confirm the syncing device in Metamory under \"Settings\" -> \"Photo Sync Tool\"."
      },
      "faq": {
        "title": "Frequently Asked Questions",
        "sync_issue": {
          "short_title": "Not syncing automatically",
          "title": "Automatic syncing by the Photo Sync Tool does not work",
          "step1": "Check whether the photo sync tool is running from the notification area (right side of the taskbar).",
          "step2": "Click the photo sync tool icon in the notification area to open the \"Dashboard,\" then check the bottom-left to verify you are signed in with the correct account. If not signed in, a screen like this will appear.",
          "step3": "Click the photo sync tool icon in the notification area to open the \"Dashboard,\" then check that the \"Auto Upload\" switch is turned on."
        },
        "world_info": {
          "short_title": "World info not syncing",
          "title": "World and user information is not synced to automatically uploaded photos",
          "step1": "Even if the photo itself has been uploaded, world and user information may not be synced yet. Please wait a few minutes and try again.",
          "step2": "If VRChat is configured not to output log files, world and user information may not sync. Please change the VRChat setting to enable log file output."
        },
        "app_not_start": {
          "short_title": "App won't start",
          "title": "The Photo Sync Tool no longer starts",
          "step1": "Check whether the photo sync tool is running from the notification area (right side of the taskbar).",
          "step2": "Other applications such as antivirus software, or updates to your PC or drivers, can sometimes prevent the app from launching.",
          "step2_note1": "Try disabling or uninstalling recently installed applications and test again.",
          "step2_note2": "If the issue does not improve, please contact the Metamory team."
        },
        "pause_delete": {
          "short_title": "Pause or delete",
          "title": "I want to pause or remove the Photo Sync Tool",
          "step1": "To pause, click the photo sync tool icon in the notification area to open the \"Dashboard,\" then turn off the \"Auto Upload\" switch.",
          "step2": "To quit, right-click the photo sync tool icon in the notification area and select \"Quit Metamory.\"",
          "step3": "To stop the photo sync tool completely, uninstall \"Metamory Client\" from Windows \"Settings\" -> \"Apps\" -> \"Installed apps\"."
        },
        "vrchat_account": {
          "short_title": "Different VRChat account",
          "title": "Automatic syncing stopped after logging into VRChat with a different account",
          "step1": "At this time, Metamory does not support syncing photos and information across multiple VRChat accounts. Please upload photos manually, or continue using automatic uploads with the account that was used when you installed the photo sync tool."
        },
        "metamory_account": {
          "short_title": "Different Metamory account",
          "title": "I created another Metamory account, but automatic syncing does not work",
          "step1": "The Metamory Photo Sync Tool can only be linked to a single Metamory account at a time.",
          "step2": "To change the linked account, sign out from the dashboard via \"Settings\" -> \"Account\" -> \"Sign Out,\" then re-authenticate."
        }
      }
    }
  },
  "urge_reload": {
    "title": "Please reload the page",
    "description": "The page has been updated. Please reload the page to see the latest information.",
    "reload": "Reload"
  },
  "plan": {
    "current_plan": "Current Plan",
    "current_use_storage": "Storage Used",
    "storage_source": {
      "title": "Storage breakdown",
      "subscription": "Subscription",
      "promotions": "Promotions",
      "valid_until": "Valid until: {{date}}",
      "no_promotions": "No active promotions",
      "permanent": "No expiration"
    },
    "payment_interval_annual_label": "Annual Payment",
    "payment_interval_annual_discount": "{{percent}}% off",
    "discount_available": "Discount available",
    "payment_interval_monthly": "Monthly Payment",
    "storage_feature": "{{storage}}GB additional storage",
    "price_format_annual": "¥{{price}}/year",
    "price_format_monthly": "¥{{price}}/month (incl. tax)",
    "upgrade_plan": "Upgrade to {{planTitle}} Plan",
    "downgrade_plan": "Downgrade to {{planTitle}} Plan",
    "features_earlyaccess": "Early access to new features",
    "features_fast_access": "Fast access to past photos",
    "features_original_image": "Original image storage",
    "features_ad_free": "Ad-free experience",
    "price_with_discount": "¥{{price}}/month ({{percent}}% off) (incl. tax)",
    "upgrade_to": "Upgrade to {{plan}} Plan",
    "downgrade_to": "Downgrade to {{plan}} Plan",
    "enjoy_plan": "Enjoy appending storage and features!",
    "back_to_plan": "Back to Plan",
    "back_to_home": "Back to Home",
    "failled_settle_title": "Failed to settle payment",
    "failled_settle_description": "A payment error has occurred. Please wait some time and try again.\nIf this occurs repeatedly, please contact Metamory",
    "processing_subscription_title": "Processing your subscription...",
    "processing_subscription_description": "Please wait a moment. Your plan will be updated shortly.",
    "subscription_timeout_title": "Your subscription is being processed",
    "subscription_timeout_description": "Processing is taking a little longer than expected. Your plan will be updated shortly.",
    "using_current_plan": "Using current plan",
    "annual_to_monthly_downgrade": "Upgrading to this plan will not result in a refund for your previous plan ({{current_plan_name}} (1 year)) payment of ¥{{current_plan_price}}.\nMetamory recommends upgrading to the <b>{{recommended_plan_name}} (1 year)</b> plan. (Upgrade available for ¥{{recommended_plan_price}})\nAre you sure you want to change your plan?",
    "limit_photos_num": "Up to {{num}}, photos",
    "free_price": "Free",
    "most_popular": "Most Popular",
    "savings_annual": "Save {{num}}yen annually",
    "management": {
      "header_title": "Manage Plan",
      "current_plan": "Current Plan",
      "next_billing_date": "Next Billing Date",
      "current_plan_expiration_date": "Current Plan Expiration Date",
      "next_billing_amount": "Next Billing Amount",
      "payment_method": "Payment Method",
      "change_payment_method": "Change",
      "cancel_plan": "Cancel Plan",
      "cancel_plan_already_canceled": "Already Cancelled",
      "resume_plan": "Resume Plan",
      "resume_plan_success": "Plan has been resumed.",
      "update_creditcard_success": "Credit card information updated successfully",
      "update_creditcard_error": "Failed to update credit card information",
      "par_one_year": "/ 1 year",
      "par_one_month": "/ 1 month"
    },
    "cancel": {
      "title": "Cancel Plan?",
      "message": "You are about to cancel your current plan ({{plan_name}}).\nIf you cancel your plan, <b>{{photo_count}} photos</b> to insufficient storage will be deleted. Automatic photo uploads will also be temporarily suspended while storage is insufficient.",
      "date": "Expected date of termination",
      "confirm_button": "Cancel Plan",
      "cancel_button": "Do Not Cancel",
      "confirm_message": "To cancel your plan, please enter your Metamory ID for confirmation.",
      "confirm_text": "Cancel Plan",
      "confirm_ok": "Confirm Cancellation",
      "success": "Plan has been cancelled."
    },
    "downgrade": {
      "title": "Change Plan",
      "message": "You are trying to change your plan {{plan_name}}. What should you do?\nIf you change your plan, {{photo_count}} of photos will be deleted due to insufficient storage. While you are running out of storage space, automatic uploading of photos will also be suspended.",
      "confirm_button": "Change Plan",
      "cancel_button": "Do Not Change",
      "date": "Changed date",
      "confirm_text": "Change Plan",
      "success": "Plan has been changed."
    },
    "confirm": {
      "title": "Switch to the {{plan}} plan?",
      "charge_amount": "You will be charged <b>{{amount}}</b> today",
      "no_immediate_charge": "No charge today",
      "next_billing_date": "Next billing date",
      "confirm_and_charge": "Confirm and pay",
      "confirm": "Confirm",
      "cancel": "Cancel",
      "processing": "Processing...",
      "preview_error": "Could not fetch the charge amount. Please try again in a moment."
    }
  },
  "timeline": {
    "empty": {
      "main": {
        "title": "No photos yet",
        "message": "Photos from public albums will appear here when shared.",
        "action": "Find users"
      },
      "me": {
        "title": "You haven't posted any photos yet",
        "message": "Upload photos to share your memories.",
        "action": "Upload photos"
      },
      "noFriends": {
        "title": "You're not following anyone yet",
        "message": "Follow users to see their photos in your timeline.",
        "action": "Find users"
      },
      "noPhotos": {
        "title": "No photos",
        "message": "There are no photos in this timeline yet."
      }
    }
  },
  "common": {
    "loading": "Loading..."
  },
  "maintenance": {
    "title": "Under Maintenance",
    "message": "We are currently performing maintenance.",
    "sub_message": "Please wait a moment."
  },
  "report": {
    "album_unavailable": "Album reporting is currently unavailable",
    "report": "Report",
    "report_photo": "Report photo",
    "report_album": "Report album",
    "report_user": "Report user",
    "dialog_title_photo": "Report this photo?",
    "dialog_title_album": "Report this album?",
    "dialog_title_user": "Report this user?",
    "reason_label": "Reason for reporting",
    "reason_inappropriate_icon": "Inappropriate icon image",
    "reason_inappropriate_name": "Inappropriate user name / ID",
    "reason_inappropriate_bio": "Inappropriate bio text",
    "reason_sexual_content": "Sexual content",
    "reason_violence": "Violence",
    "reason_harassment": "Harassment",
    "reason_other": "Other",
    "comment_placeholder": "Please provide more details (optional)",
    "submit": "Submit report",
    "cancel": "Cancel",
    "success": "Report submitted successfully",
    "error": "Failed to submit report",
    "already_reported": "You have already reported this",
    "guidelines_link": "guidelines",
    "guidelines_message": "Please review our <0>guidelines</0> before reporting."
  },
  "sensitive": {
    "overlay_message": "Sensitive content",
    "show_button": "Show",
    "birth_date": "Date of birth",
    "birth_date_input_title": "Set date of birth",
    "birth_date_required": "Date of birth is required",
    "birth_date_invalid": "Please enter a valid date of birth",
    "birth_date_under_18": "Not available for users under 18",
    "birth_date_setting": "Date of birth settings",
    "birth_date_setting_description": "Used to display sensitive content",
    "birth_date_change_restriction": "Date of birth can be changed once every 3 months",
    "birth_date_dialog_description": "Please enter your date of birth to view this content.\n(You can change it later on the settings page)",
    "global_filter_title": "Sensitive content filter",
    "global_filter_description": "Controls the display of sensitive content",
    "global_filter_enabled": "Enabled",
    "global_filter_disabled": "Disabled",
    "global_filter_restriction_title": "Cannot change settings",
    "global_filter_restriction_message": "Users under 18 or without a date of birth set cannot disable the sensitive content filter.",
    "birth_date_next_change_date": "Next change date: {{date}}",
    "birth_date_save": "Save date of birth",
    "birth_date_updated": "Date of birth updated",
    "sensitive_album_confirm_message": "This album contains sensitive content.\nDo you want to view it?",
    "under_18_cannot_view_album": "Users under 18 cannot view this content",
    "login_required_message": "This album contains sensitive content.\nPlease log in to view it."
  },
  "muted": {
    "overlay_message": "Muted user",
    "show_button": "Show",
    "album_confirm_message": "This album is owned by a muted user.\nDo you want to view it?"
  },
  "desktop_callback": {
    "redirecting": "Redirecting to Metamory Client...",
    "redirecting_description": "Click \"Open\" when prompted by your browser.",
    "having_trouble": "App didn't open?",
    "manual_description": "If the app didn't open automatically, copy the code below and paste it into the Metamory Client.",
    "copy": "Copy",
    "copied": "Copied",
    "expiry_warning": "This code expires in approximately 5 minutes.",
    "missing_params": "Authentication parameters not found. Please sign in again from the client.",
    "expiry_warning_minutes_one": "This code expires in approximately {{count}} minute.",
    "expiry_warning_minutes_other": "This code expires in approximately {{count}} minutes.",
    "open_client": "Open Metamory Client",
    "never_share": "Paste this code only into the Metamory desktop app on this computer. Never share it with anyone, including people claiming to be Metamory staff."
  },
  "desktop_handoff": {
    "title": "Sign in to the desktop app",
    "question": "Sign in to the Metamory desktop app as {{name}}?",
    "description": "Approving lets the Metamory desktop app on this computer sign in as this account. If you did not start signing in from the desktop app, cancel.",
    "approve": "Approve",
    "cancelled_title": "Sign-in cancelled",
    "cancelled_description": "Nothing was sent to the desktop app. You can close this tab.",
    "invalid_params": "This sign-in link is invalid. Please sign in again from the Metamory desktop app.",
    "not_enabled": "Desktop app sign-in is not enabled in this environment.",
    "failed": "Could not prepare the desktop app sign-in. Please try again",
    "error_title": "Cannot sign in to the desktop app",
    "framed": "This page cannot be opened inside another page. Please sign in again from the Metamory desktop app.",
    "refused": "Desktop app sign-in is not available for your current sign-in session.",
    "account_error": "Could not load your account.",
    "not_you": "Not you? Sign out"
  },
  "history": {
    "disappeared": "Some history is no longer available.",
    "user": {
      "empty": "No interaction history yet",
      "empty_hint": "Download the photo sync tool to look back on your memories.",
      "more": "Show more",
      "expand": "Show interaction history for {{name}}",
      "collapse": "Hide interaction history for {{name}}",
      "load_failed": "Could not load interaction history."
    },
    "title": "Interaction history",
    "worlds": "Worlds",
    "users": "Users",
    "search": {
      "worlds_placeholder": "Search history by world name",
      "users_placeholder": "Search history by user name",
      "worlds_filter": "World:",
      "users_filter": "User:",
      "cancel": "Cancel search",
      "clear": "Clear search filter",
      "change_named": "Change search filter: {{name}}",
      "loading": "Searching candidates",
      "failed": "Could not load candidates.",
      "empty": "No matching history.",
      "refine": "More than 50 matches were found. Refine your search."
    },
    "coming_soon": "Coming soon",
    "order": "Sort order",
    "newest": "Newest first",
    "oldest": "Oldest first",
    "show_available": "Show available history",
    "invalid_link": "Enter a valid date and time including a time zone.",
    "outside_range": "The requested date is outside your available history.",
    "visit_missing": "This visit was not found or is currently unavailable.",
    "empty": "No world visits yet. Sync your visit history with the sync tool.",
    "sync_tool": "About the sync tool",
    "retry": "Retry",
    "index_changed": "Visit history changed. Refresh and try again.",
    "range_error": "Could not load this part of your history.",
    "loading": "Loading visit history",
    "scroll_date": "Scroll by visit date",
    "detail": {
      "expand": "Show visit details",
      "collapse": "Hide visit details",
      "open_world_url": "Open world in a new tab",
      "participant_count": "{{count}} users",
      "photo_count": "{{count}} photos",
      "duration": "{{hours}}h {{minutes}}m",
      "staying": "Currently visiting",
      "join": "Join",
      "leave": "Leave",
      "other_participants": "{{count}} more",
      "all_participants": "Participants",
      "not_registered": "Not registered with Metamory",
      "encounter_count_label": "Encounters",
      "last_encounter_label": "Last encounter",
      "encounter_count": "{{count}}",
      "open_profile": "View profile",
      "profile_unavailable": "A profile is unavailable because this person is not registered with Metamory.",
      "encounter_load_failed": "Could not load encounter information.",
      "detail_load_failed": "Could not load the visit details.",
      "visit_not_found": "This visit could not be found.",
      "retry": "Retry",
      "open_photo": "Open photo from {{date}}",
      "timeline_truncated": "Later history entries are omitted.",
      "create_my_album": "Create my album",
      "album_name": "{{date}} at {{world}}",
      "you": "You",
      "name_separator": ", ",
      "join_sentence": " joined",
      "leave_sentence": " left",
      "show_participants": "Show {{count}} participants",
      "duration_hours": "{{hours}}h"
    },
    "album_invitation_failed": "The album has been created, but some invitations failed. Adjust recipients and press Complete to retry unfinished invitations. Back opens the created album.",
    "album_no_invitations": "Participants will not be invited with this visibility setting.",
    "album_invitation_limit": "Up to 100 invitations may be pending. Select at most 100 recipients or enable automatic approval."
  },
  "world": {
    "search_no_result": "No worlds found",
    "search_no_result_description": "Try a different world name or identifier.",
    "search_limit": "Can’t find a world?",
    "search_limit_description": "Up to 50 candidates are shown. Add more search terms to narrow the results."
  },
  "passkey": {
    "title": "Passkeys",
    "description": "With a passkey, you can sign in with your fingerprint, face, or screen lock instead of a password. Passkeys are saved on your device or in your password manager.",
    "add": "Add passkey",
    "added": "Passkey added",
    "empty": "No passkeys yet",
    "empty_description": "Add a passkey to sign in without a password next time",
    "unnamed": "Unnamed passkey",
    "created_at": "Added {{date}}",
    "attachment_platform": "Built into a device",
    "attachment_cross_platform": "Security key or another device",
    "delete_named": "Delete {{name}}",
    "delete_confirm": "Delete \"{{name}}\"?\nYou will no longer be able to sign in with this passkey. Remove any copy left on your device or in your password manager from its own settings.",
    "deleted": "Passkey deleted",
    "delete_failed": "Couldn't delete the passkey",
    "list_error": "Couldn't load your passkeys",
    "canceled": "The passkey request was canceled",
    "already_registered": "This device already has a passkey for this account",
    "not_supported": "Passkeys aren't available in this browser or on this device",
    "failed": "Couldn't use a passkey. Please try again later",
    "limit_reached": "You've reached the maximum number of passkeys. Delete one you no longer use, then add a new one",
    "nudge": "Add a passkey to sign in with your fingerprint or face next time?",
    "nudge_action": "Add"
  }
}
